import React from 'react';
import { Stack, Typography } from '@mui/material';
import AssetLogo from 'sections/AssetLogo';
import { EnvironmentOutlined } from '@ant-design/icons';
import { useTheme } from '@mui/material/styles';

export interface BankInfoCellData {
  bankName: string;
  bankLogo?: string | null;
  locationName: string;
}

interface BankInfoCellProps {
  data: BankInfoCellData | null;
  useCompactViewStyle?: boolean;
  showUnknown?: boolean;
  inGrid?: boolean;
}

const BankInfoCell = ({ data, useCompactViewStyle, showUnknown, inGrid = false }: BankInfoCellProps) => {
  const theme = useTheme();
  const fs = inGrid ? theme.typography.body2.fontSize : (useCompactViewStyle ? 10 : 12);
  const logoSize = inGrid ? 'sm' : useCompactViewStyle ? 'xs' : 'sm';

  if (!data) {
    if (!showUnknown) return null;
    return (
      <Stack direction="row" spacing={inGrid ? 1.5 : useCompactViewStyle ? 1 : 1.5} alignItems="center" ml={1} height="100%">
        <AssetLogo logo={null} name="?" size={logoSize as 'xs' | 'sm'} />
        <Typography variant="caption" fontSize={fs} color="text.secondary">
          Unknown Bank
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack direction="row" spacing={inGrid ? 1 : useCompactViewStyle ? 1 : 1.5} alignItems="center" ml={inGrid ? 0 : 1} height="100%">
      <AssetLogo logo={data?.bankLogo} name={data?.bankName} size={logoSize as 'xs' | 'sm'} />
      <Stack spacing={0} justifyContent="center" minWidth={0}>
        <Typography variant="caption" fontSize={fs} lineHeight={inGrid ? 1.35 : useCompactViewStyle ? 1.2 : 1.3} color={'text.primary'} noWrap>
          {data?.bankName}
        </Typography>
        {data?.locationName && (
          <Stack direction="row" alignItems="center" spacing={0.4} minWidth={0}>
            <EnvironmentOutlined style={{ fontSize: fs, color: theme.palette.text.secondary, display: 'flex', flexShrink: 0 }} />
            <Typography variant="caption" color="text.secondary" fontSize={fs} lineHeight={inGrid ? 1.35 : useCompactViewStyle ? 1.2 : 1.3} noWrap>
              {data.locationName}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default BankInfoCell;
